import { render } from "./EquipaMembroView.vue?vue&type=template&id=2bb54a1c&scoped=true"
import script from "./EquipaMembroView.vue?vue&type=script&lang=js"
export * from "./EquipaMembroView.vue?vue&type=script&lang=js"

import "./EquipaMembroView.vue?vue&type=style&index=0&id=2bb54a1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb54a1c"]])

export default __exports__